import React, { useState } from 'react'
import { useTranslation } from "react-i18next";
import { Card, Row, Col } from "react-bootstrap"
import '../../../../../styles/css/TimeLineCard.css'
//import "office-ui-fabric-react/dist/css/fabric.css";
import { Icon } from '@fluentui/react/lib/Icon';
import moment from "moment-timezone"
import { ScrollablePane, ScrollbarVisibility } from '@fluentui/react/lib/ScrollablePane';
import { useOfGetCompactViewMode } from '../../../../../hooks/services/sBook/useOfMessage';
import List from '../../../../Templates/List';
import { ActionButton, Dropdown, getTheme, IconButton, mergeStyleSets, PrimaryButton, SpinnerSize, Toggle, TooltipHost, TooltipOverflowMode } from '@fluentui/react';
import { download, isBookApproverOrCreator, isNullUndefined, setGlobalCompactViewMode } from '../../../../../common/Helpers';
import CLabel from '../../../../Common/CLabel';
import SectionStadistic from '../SectionStadistic';
import ListPagination from '../../../../Templates/List/ListPagination';
import { css } from '@fluentui/react/lib/Utilities';
import BookStadistic from '../../V3/BookStadistic';
import MessageIconStatus from '../../MessageIconStatus';
import { getMessageTreeByObjectByPartyExcelData } from '../../../../../services/sBook/message.service';
import SidePanelCreate from '../../MessageTree/SidePanelCreate';
import { ExportBookOrMessageToPdf } from '../../../../../common/FileManager/ExportFunction';
import { useSelector } from 'react-redux';
import CTextBox from '../../../../Common/CTextBox';
import { enum__BOOK_SECTION_CLASS, enum__MessageStatus } from '../../../../../common/Dictionaries';
import { getReportPendingCommunications } from '../../../../../services/sBook/report.service';
import Loading from '../../../../Templates/Site/Loading';

function MessageTree(props) {
    const { t } = useTranslation();
    const { token: currentAuth } = useSelector((state) => state.auth);

    const iconButtonStyles = { root: { float: 'left', height: 'inherit', padding: '10px' } };


    //Parametros de entrada.
    const inputParam_BookObject = props.bookObject !== null && props.bookObject !== undefined ? props.bookObject : null;
    const inputParam_SetterMessageObject = props.setterMessageObject !== null && props.setterMessageObject !== undefined ? props.setterMessageObject : null;
    const inputParam_SectionList = props.sectionList !== null && props.sectionList !== undefined ? props.sectionList : null;
    const inputParam_ObjMessageList = props.objMessageList !== null && props.objMessageList !== undefined ? props.objMessageList : null;
    const inputParam_ObjMessageListGridType = props.objMessageListGridType !== null && props.objMessageListGridType !== undefined ? props.objMessageListGridType : null;
    
    const inputParam_SetterObjMessageListGridType = props.setterObjMessageListGridType !== null && props.setterObjMessageListGridType !== undefined ? props.setterObjMessageListGridType : null;
    const inputParam_SetterObjMessageList = props.setterObjMessageList !== null && props.setterObjMessageList !== undefined ? props.setterObjMessageList : null;
    const inputParam_UserProps = props.userProps !== null && props.userProps !== undefined ? props.userProps : null;
    const inputParam_UserName = props.userName !== null && props.userName !== undefined ? props.userName : null;
    const inputParam_EditMode = props.editMode !== null && props.editMode !== undefined ? props.editMode : false;
    const inputParam_SelectedMessageId = props.selectedMessageId !== null && props.selectedMessageId !== undefined ? props.selectedMessageId : null;
    const inputParam_SetterSelectedMessageId = props.setterSelectedMessageId !== null && props.setterSelectedMessageId !== undefined ? props.setterSelectedMessageId : null;

    const inputParam_SelectedSectionStatusItem = props.selectedSectionStatusItem !== null && props.selectedSectionStatusItem !== undefined ? props.selectedSectionStatusItem : null;
    const inputParam_ObjMessageSelected = props.objMessageSelected !== null && props.objMessageSelected !== undefined ? props.objMessageSelected : null;

    const inputParam_SetSelectedItem = props.setterSelectedItem !== null && props.setterSelectedItem !== undefined ? props.setterSelectedItem : null;
    const inputParam_SelectedItem = props.selectedItem !== null && props.selectedItem !== undefined ? props.selectedItem : null;

    const inputParam_SetFireGetMessage = props.setFireGetMessage !== null && props.setFireGetMessage !== undefined ? props.setFireGetMessage : null;

    const inputParam_FilterMessageText = props.filterMessageText !== null && props.filterMessageText !== undefined ? props.filterMessageText : null;
    const inputParam_SetFilterMessageText = props.setFilterMessageText !== null && props.setFilterMessageText !== undefined ? props.setFilterMessageText : null;

    const inputParam_ForceFilterMessages = props.forceFilterMessages !== null && props.forceFilterMessages !== undefined ? props.forceFilterMessages : null;
    const inputParam_SetForceFilterMessages = props.setForceFilterMessages !== null && props.setForceFilterMessages !== undefined ? props.setForceFilterMessages : null;

    const inputParam_MessageCounts = props.messageCounts !== null && props.messageCounts !== undefined ? props.messageCounts : null;
    
    const inputParam_SetDataFilled = props.setDataFilled !== null && props.setDataFilled !== undefined ? props.setDataFilled : null;

    const [selectedStadisticType, setSelectedStadisticType] = useState(null);

    //Parametros de componente.
    const [isPanelOpen, setIsPanelOpen] = useState(false);
    const [lastSectionFilterFired, setLastSectionFilterFired] = useState("LastMessage");

    

    
    const [tglCompactView, setTglCompactView] = useState(null);
    const [selectedFilterSectionId, setSelectedFilterSectionId] = useState(-1);
    const [lasSectionCollapsedExpanded, setLasSectionCollapsedExpanded] = useState(null);
    const [selectedFilterSectionName, setSelectedFilterSectionName] = useState("");
    useOfGetCompactViewMode("messageTreeBox", tglCompactView, setTglCompactView, false)

    const handleExport = (handleDownload, listField) => {  
        getMessageTreeByObjectByPartyExcelData(inputParam_BookObject.id, inputParam_UserProps.partyId, inputParam_UserProps.partyMemberId).then((serviceResponse) => {
            handleDownload(serviceResponse.data, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,");
        });
    }; 

    const handleExportTree = () => {  
        getMessageTreeByObjectByPartyExcelData(inputParam_BookObject.id, inputParam_UserProps.partyId, inputParam_UserProps.partyMemberId).then((serviceResponse) => {
            download(serviceResponse.data, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,", document.getElementById("exportTree"), "Export", "");
        });
    }

    const handleExportPendingTree = () => {  
        const itemToSend = {
            timeOffset: 0,
            calendar_selector_id: 0,
            display_aggregation_id: 0,
            l_elements: [],
            dt_ini: null,
            dt_fin: null,
        }
        getReportPendingCommunications(itemToSend, inputParam_BookObject.id).then((response) => {
            if (response.data !== null) { 
                download(response.data, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,", document.getElementById("exportTree"), "Export", "");
            } else {
                //##Mensaje de exito.
            }
        },
        (error) => {
        }).catch((ex) => {
        });
    }

    const handleExportTreePdf = async () => {  
        await ExportBookOrMessageToPdf(t, inputParam_BookObject, inputParam_UserProps.partyMemberId, 0, null, currentAuth.token.clientName, true, currentAuth.token.userName)
    };

    //Funciones de componente.

    //Eventos de componente.
    const onCreateMessage = () => {
        if (inputParam_BookObject.id !== 0) {
            setIsPanelOpen(true);
        } else {
            alert("Debe crear el libro primero.");
        }
    };

    const onRefreshMessageTree = () => {
        inputParam_SetterObjMessageList(null);
        setLastSectionFilterFired("LastMessage")
    };

    const onCardTreeSelected = (messageObject) => {
        inputParam_ObjMessageList.data.data.forEach(element => {
            element.l_items.forEach(elementItem => {
                if (elementItem.item_message.id === messageObject.id) {
                    elementItem.item_message.isUnread = false;
                }
            });
        });
        inputParam_SetterObjMessageList && inputParam_SetterObjMessageList(inputParam_ObjMessageList);


        messageObject.fronPropertySectionName = messageObject.seccionName;      
        inputParam_SetterMessageObject && inputParam_SetterMessageObject(messageObject)
        inputParam_SetterSelectedMessageId && inputParam_SetterSelectedMessageId(messageObject.id);
        setLastSectionFilterFired("LastMessage")
        
        //##AQUI##
        inputParam_SetDataFilled && inputParam_SetDataFilled(false);
    };

    const onCompactViewChange = (e, checked) => {
        setTglCompactView(checked);
        setGlobalCompactViewMode("messageTreeBox", checked)
        inputParam_SetterObjMessageListGridType && inputParam_SetterObjMessageListGridType(prevState => ({
            ...prevState,
            fireUpdate: true
        }));
    };

    const onCardTreeLateralSelected = (messageObject, messageTrunkObject) => {
        messageObject.partyId = messageTrunkObject.partyId;
        messageObject.sectionId = messageTrunkObject.sectionId;
        messageObject.seccionPartyId = messageTrunkObject.seccionPartyId;
        messageObject.fronPropertySectionName = messageTrunkObject.fronPropertySectionName;      
        inputParam_SetterMessageObject && inputParam_SetterMessageObject(messageObject)
        inputParam_SetterSelectedMessageId(messageObject.id);
        setLastSectionFilterFired("LastMessage")

        //##AQUI##
        inputParam_SetDataFilled && inputParam_SetDataFilled(false);
    };

    //Constante resagada, esto dado que deben existir los eventos del comonente para poder ser invocados en array de toolbar.

    const displayToolBarCommunication = true;

    const onLoadSectionFilter = () => {
        let array = []
        array.push({ key: -1, text: t('data-lang-placeholder-selectoption'), title: t('data-lang-placeholder-selectoption') })
        inputParam_SectionList.map((item, index) => array.push({  key: item.seccionId, text: item.seccionName, title: item.seccionName }));

        return array
    };

    const onMessageFilterTextChange = (value, textBoxName) => {
        inputParam_SetFilterMessageText && inputParam_SetFilterMessageText(value);
    };

    const onFilterMessages = () => {
        inputParam_SetForceFilterMessages(true);
    };
    
    const onHideShowSectionTreeAll = () => {
        const value = lasSectionCollapsedExpanded === null ? false : !lasSectionCollapsedExpanded;

        inputParam_ObjMessageList.data.data.forEach(element => {
            element.show = value;
        });
        
        setLasSectionCollapsedExpanded(value)
        inputParam_SetterObjMessageList && inputParam_SetterObjMessageList(inputParam_ObjMessageList);
    };

    const onHideShowSectionTree = (sectionId, sectionShow) => {
        let collapsedCount = 0
        inputParam_ObjMessageList.data.data.forEach(element => {
            if (element.seccionId === sectionId) {
                element.show = !sectionShow;
                if (!element.show) {
                    collapsedCount++;
                }
            }
            else {
                if (!element.show) {
                    collapsedCount++;
                }
            }
        });

        if (collapsedCount === inputParam_ObjMessageList.data.data.length) {
            setLasSectionCollapsedExpanded(false)
        }
        else {
            setLasSectionCollapsedExpanded(sectionId + sectionShow)
        }
        inputParam_SetterObjMessageList && inputParam_SetterObjMessageList(inputParam_ObjMessageList);
    };

    const onSectionFilterChange = (ev, item) => {
        setSelectedFilterSectionId(item.key);
        setSelectedFilterSectionName(item.title);
        
        setLastSectionFilterFired("SectionDropDown")
    }
    
    const checkIfSelectedSectionStadisticTypeCanBeDisplay = (message) => {
        let flag = true;

        if (selectedStadisticType === null) {
            return flag;
        }
        
        switch (selectedStadisticType.type) {
            case "isInPreparation":
                flag = !isNullUndefined(message.item_message.isInPreparation) ? message.item_message.isInPreparation : false;
                break;
            case "isInToVisa":
                flag = !isNullUndefined(message.item_message.isInToVisa) ? message.item_message.isInToVisa : false;
                break;
            case "isTotalMessage":
                flag = true;
                break;
            case "isReceived":
                flag = message.item_message.isReceived;
                break;
            case "isSent":
                flag = message.item_message.isSent;
                break;
            case "isUnread":
                flag = message.item_message.isUnread;
                break;
            case "isPending":
                flag = message.item_message.isPending;
                break;
            case "isExpired":
                flag = message.item_message.isExpired;
                break;
            case "isPendingWaiting":
                flag = message.item_message.isPendingWaiting;
                break;
            case "isExpiredWaiting":
                flag = message.item_message.isExpiredWaiting;
                break;
            default:
                break;
        }

        return flag
    }
    const classNames = mergeStyleSets({
        // Applied to make content overflow (and tooltips activate)
        overflow: {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          width: "99%",
        },
        // Just to look nice
        example: { marginTop: 20, selectors: { '> *:first-child': { paddingBottom: 10 } } },
        parent: {
          padding: 10,
          border: '2px dashed ' + getTheme().palette.neutralTertiary,
          selectors: { '> *:last-child': { marginTop: 10 } },
        },
      });


    //Render de componente.
    return (
        <Card className='book-info-form h-100'>
            <Card.Header className="card-header-compact">
                <Card.Title className="d-flex justify-content-between">
                    <TooltipHost
                        overflowMode={TooltipOverflowMode.Self}
                        hostClassName={css(true && classNames.overflow)}
                        content={<b>{ `${t('data-lang-boxname-communications')}` }</b>}
                    >
                        {<b>{ `${t('data-lang-boxname-communications')}` }</b>}
                    </TooltipHost>
                    <IconButton
                        menuIconProps={{ iconName: 'MoreVertical' }}
                        role="button"
                        className="action-menu-list-toolbar"
                        aria-haspopup
                        styles={iconButtonStyles}
                        menuProps={{
                            items: [
                                {
                                    key: 'export',
                                    iconProps: { iconName: 'ExcelLogo' },
                                    text: t('data-lang-btn-exportbookcommunicationsexcel'),
                                    onClick: () => handleExportTree(),
                                },
                                {
                                    key: 'exportExcelPending',
                                    iconProps: { iconName: 'ExcelLogo' },
                                    text: t('data-lang-btn-exportbookcommunicationspending'),
                                    onClick: () => handleExportPendingTree(),
                                },
                                {
                                    key: 'exportpdf',
                                    iconProps: { iconName: 'PDF' },
                                    text: t('data-lang-btn-exportbookcommunicationspdf'),
                                    onClick: () => handleExportTreePdf(),
                                },
                            ],
                        }}
                    />
                </Card.Title>
            </Card.Header>
            <Card.Footer className='pt-2' style={{borderTop: "1px solid rgba(0, 0, 0, 0.125)"}}>
                <BookStadistic objMessageList={ inputParam_ObjMessageList } userProps={ inputParam_UserProps }  setterSelectedItem={inputParam_SetSelectedItem} selectedItem={inputParam_SelectedItem} />
            </Card.Footer>
            <Card.Footer className='pt-2'>

                    <TooltipHost
                        overflowMode={TooltipOverflowMode.Self}
                        hostClassName={css(true && classNames.overflow)}
                        content={<h4>{ `${t('data-lang-boxname-section')} - ${ lastSectionFilterFired === "SectionDropDown" ? (selectedFilterSectionId === -1 ? (inputParam_ObjMessageSelected ? inputParam_ObjMessageSelected.fronPropertySectionName : "") : selectedFilterSectionName) : (inputParam_ObjMessageSelected ? inputParam_ObjMessageSelected.fronPropertySectionName : "") }` }</h4>}
                    >
                        {<h6><b>{ `${t('data-lang-boxname-section')} - ${ lastSectionFilterFired === "SectionDropDown" ? (selectedFilterSectionId === -1 ? (inputParam_ObjMessageSelected ? inputParam_ObjMessageSelected.fronPropertySectionName : "") : selectedFilterSectionName) : (inputParam_ObjMessageSelected ? inputParam_ObjMessageSelected.fronPropertySectionName : "") }` }</b></h6>}
                    </TooltipHost>
            </Card.Footer>
            <Card.Footer style={{padding: "0px"}}>
                <div className='book-toolbar d-flex float-end'>
                    {
                        inputParam_SectionList && !tglCompactView &&
                        <div className="d-flex pe-2 ps-2 pt-1">
                            <CLabel aditionalStyles={ { fontWeight: "400", fontSize: "14px", paddingTop: "6px", color: "rgb(50, 49, 48)" } } labelText={t('data-lang-lbl-section')} black={false} />
                            <Dropdown
                                placeholder={t('data-lang-placeholder-selectoption')}
                                options={onLoadSectionFilter()}
                                selectedKey={selectedFilterSectionId}
                                onChange={onSectionFilterChange}
                                styles={ {title: { height: "27px" }} }
                                className="pt-1"
                            />
                        </div>
                    }
                    {
                        inputParam_EditMode && displayToolBarCommunication && inputParam_BookObject && inputParam_BookObject.hasMilestoneProblem === false &&
                        <>
                            <j className="d-none d-sm-block my-auto">
                                {
                                    inputParam_BookObject.l_book_milestone.some(x => x.sectionClassId === enum__BOOK_SECTION_CLASS.APERTURA) === true ?
                                    <>
                                        {
                                            //[##CODELCO-CARD-6-##]
                                            //No se pueden generar otras comunicaciones después del hito de cierre
                                            ((isNullUndefined(inputParam_BookObject.hasMilestone) || inputParam_BookObject.hasMilestone === false) || (inputParam_BookObject.hasMilestone === true && (inputParam_BookObject.canSendMessage || inputParam_UserProps.partyId === inputParam_BookObject.milestoneToEndPartyId))) &&
                                            <PrimaryButton
                                                onClick={ onCreateMessage }
                                                //style={{ display: inputParam_UserProps ? ((inputParam_UserProps.roleId === 2 || inputParam_UserProps.roleId === 1) ? "unset" : "none") : "none" }}
                                                style={{ display: inputParam_UserProps ? (isBookApproverOrCreator(inputParam_UserProps) ? "unset" : "none") : "none" }}
                                                iconProps={{ iconName: 'NewMail', style: { color: '#ffffff' } }}
                                                allowDisabledFocus
                                            >
                                                { t('data-lang-btn-create') }
                                            </PrimaryButton>
                                        }
                                    </> :
                                        <PrimaryButton
                                            onClick={ onCreateMessage }
                                            //style={{ display: inputParam_UserProps ? ((inputParam_UserProps.roleId === 2 || inputParam_UserProps.roleId === 1) ? "unset" : "none") : "none" }}
                                            style={{ display: inputParam_UserProps ? (isBookApproverOrCreator(inputParam_UserProps) ? "unset" : "none") : "none" }}
                                            iconProps={{ iconName: 'NewMail', style: { color: '#ffffff' } }}
                                            allowDisabledFocus
                                        >
                                            { t('data-lang-btn-create') }
                                        </PrimaryButton>
                                }
                            </j>
                            <j className="d-block d-sm-none">
                                {
                                    inputParam_BookObject.l_book_milestone.some(x => x.sectionClassId === enum__BOOK_SECTION_CLASS.APERTURA) === true ?
                                    <>
                                        {
                                            //[##CODELCO-CARD-6-##]
                                            //No se pueden generar otras comunicaciones después del hito de cierre
                                            ((isNullUndefined(inputParam_BookObject.hasMilestone) || inputParam_BookObject.hasMilestone === false) || (inputParam_BookObject.hasMilestone === true && (inputParam_BookObject.canSendMessage || inputParam_UserProps.partyId === inputParam_BookObject.milestoneToEndPartyId))) &&
                                            <TooltipHost content={ t('data-lang-btn-create') } >
                                                <ActionButton
                                                    onClick={ onCreateMessage }
                                                    //style={{ display: inputParam_UserProps ? ((inputParam_UserProps.roleId === 2 || inputParam_UserProps.roleId === 1) ? "unset" : "none") : "none" }}
                                                    style={{ display: inputParam_UserProps ? (isBookApproverOrCreator(inputParam_UserProps) ? "unset" : "none") : "none" }}
                                                    iconProps={{ iconName: 'NewMail' }}
                                                    allowDisabledFocus
                                                />
                                            </TooltipHost>  
                                        }
                                    </> : 
                                    <TooltipHost content={ t('data-lang-btn-create') } >
                                        <ActionButton
                                            onClick={ onCreateMessage }
                                            //style={{ display: inputParam_UserProps ? ((inputParam_UserProps.roleId === 2 || inputParam_UserProps.roleId === 1) ? "unset" : "none") : "none" }}
                                            style={{ display: inputParam_UserProps ? (isBookApproverOrCreator(inputParam_UserProps) ? "unset" : "none") : "none" }}
                                            iconProps={{ iconName: 'NewMail' }}
                                            allowDisabledFocus
                                        />
                                    </TooltipHost> 
                                }
                            </j>

                            <j className="d-none d-sm-block">
                                <ActionButton onClick={ onRefreshMessageTree } style={{ display: "unset" }} iconProps={{ iconName: 'Refresh' }} allowDisabledFocus>
                                    { t('data-lang-btn-refresh') }
                                </ActionButton>
                            </j>
                            <j className="d-block d-sm-none">
                                <TooltipHost content={ t('data-lang-btn-refresh') } >
                                    <ActionButton onClick={ onRefreshMessageTree } style={{ display: "unset" }} iconProps={{ iconName: 'Refresh' }} allowDisabledFocus />
                                </TooltipHost>  
                            </j>
                        </>
                    }
                    <j className="d-none d-sm-block">
                        <Toggle
                            checked={ tglCompactView !== null ? tglCompactView : false }
                            onChange={ onCompactViewChange }
                            role="checkbox"
                            onText={ t('data-lang-lbl-gridview') }
                            offText={ t('data-lang-lbl-treeview') }
                            styles={ {root:{ paddingTop: "10px", float: "right", display: "flex"}, label: {marginRight : "5px"}} }
                        />
                    </j>
                    <j className="d-block d-sm-none">
                        <TooltipHost content={ tglCompactView !== null ? (tglCompactView ? t('data-lang-lbl-gridview') : t('data-lang-lbl-treeview')) : " " } >
                            <Toggle
                                checked={ tglCompactView !== null ? tglCompactView : false }
                                onChange={ onCompactViewChange }
                                role="checkbox"
                                onText=" "
                                offText=" "
                                styles={ {root:{ paddingTop: "10px", float: "right", display: "flex"}, label: {marginRight : "5px"}} }
                            />
                        </TooltipHost>  
                    </j>

                </div>
            </Card.Footer>
            <Card.Footer className='pt-2' style={{borderTop: "1px solid rgba(0, 0, 0, 0.125)"}}>
                <SectionStadistic
                    objMessageList={ inputParam_ObjMessageList }
                    lastSectionFilterFired={lastSectionFilterFired}
                    selectedFilterSectionId={ selectedFilterSectionId }
                    objMessageSelected={ inputParam_ObjMessageSelected }
                    setterSelectedItem={ setSelectedStadisticType }
                    selectedItem={ selectedStadisticType }
                    />
            </Card.Footer>
            <Card.Footer className='pt-2'>
                <Row>
                    <Col><h6><b>{t('data-lang-boxname-communicationlist')}</b></h6></Col>
                    <Col className='d-flex col-auto ms-auto'>
                        <div>{t('data-lang-btn-filter')}</div>&nbsp;
                        <CTextBox
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    e.preventDefault();
                                    onFilterMessages();
                                }
                            }}
                            controlValue={inputParam_FilterMessageText}
                            setterControlValue={onMessageFilterTextChange}
                            style={{width: '200px', height: '29px'}}
                        />
                        <IconButton onClick={onFilterMessages} iconProps={{iconName: "Filter"}} />
                    </Col>
                </Row>
            </Card.Footer>
                {
                    inputParam_MessageCounts === 0 && 
                    <Card.Body className='overflow-auto card-body-no-padding h-100'>
                        <Row className="h-100">
                            <Col className="d-flex align-items-center justify-content-center">
                                <div>{t('data-lang-lbl-nomessages')}</div>
                            </Col>
                        </Row>
                    </Card.Body>
                }
                {
                    (inputParam_MessageCounts === null || inputParam_MessageCounts > 0) && 
                    <>
                        {
                            !(inputParam_ObjMessageListGridType  && inputParam_ObjMessageListGridType.data && inputParam_ObjMessageList && inputParam_ObjMessageList.data.data) &&
                            <Card.Body className='overflow-auto card-body-no-padding h-100'>
                                <Row className="h-100">
                                    <Col className="d-flex align-items-center justify-content-center">
                                        <Loading
                                            inputParam_ShowLoading={true}
                                            inputParam_ShowText={false}
                                            inputParam_Width={'35px'}
                                            inputParam_Height={'35px'}
                                            inputParam_Left={""}
                                            inputParam_Style={{marginTop: 0}}
                                            inputParam_ColClassName={"me-2"}
                                            inputParam_MarginLeft={"auto"}
                                            inputParam_SpinnerSize={SpinnerSize.medium} />
                                    </Col>
                                </Row>
                            </Card.Body>
                        }
                        {
                            (inputParam_ObjMessageListGridType  && inputParam_ObjMessageListGridType.data && inputParam_ObjMessageList && inputParam_ObjMessageList.data.data) &&
                            <>
                                <Card.Body className='overflow-auto card-body-no-padding h-100'>
                                    { tglCompactView && inputParam_ObjMessageListGridType && inputParam_ObjMessageListGridType.data &&
                                        <List
                                            manipulateLocalData={ true }
                                            className="no-compact-list big-header"
                                            listLocalStoragePageSizeVariableName="messageTree"
                                            data={ (inputParam_ObjMessageListGridType !== null ? inputParam_ObjMessageListGridType : []) }
                                            setData={ inputParam_SetterObjMessageListGridType }
                                            columns={ (inputParam_ObjMessageListGridType && inputParam_ObjMessageListGridType.data) ? [
                                                {
                                                    key: 'messageCode',
                                                    name: t('data-lang-lbl-code'),
                                                    fieldName: 'messageCode',
                                                    minWidth: 250,
                                                    maxWidth: 250,
                                                    onRender:(item) => {
                                                        return  <div className={`h-100 w-100 ${ item.id === inputParam_SelectedMessageId ? "selected-card" : "" }`} onClick={() => onCardTreeSelected(item)}>
                                                                        <div className={
                                                                            ` 
                                                                                ${ item.isUnread ? "status-card-yellow " : " "}
                                                                                ${ !item.isUnread &&
                                                                                    !item.isPending &&
                                                                                    !item.isExpired? " status-card-green" : " "} `
                                                                        }>
                                                                            <div
                                                                                
                                                                                className={
                                                                                    `timeline-card-nested  
                                                                                    ${ item.isPending ? " status-card-orange" : " "}
                                                                                    `
                                                                                }
                                                                            >
                                                                                <div
                                                                                    className={
                                                                                        `timeline-card-nested  
                                                                                        ${ item.isExpired ? " status-card-red" : " "}
                                                                                        `
                                                                                    }
                                                                                >
                                                                                    <div className='ps-2'>
                                                                                    <Row><Col style={{whiteSpace: "break-spaces"}}><CLabel labelText={t('data-lang-lbl-code')} labelValue={item.messageCode} /> </Col></Row>
                                                                                    <Row><Col style={{whiteSpace: "break-spaces"}}><CLabel labelText={t('data-lang-lbl-section')} labelValue={item.seccionName} /> </Col></Row>
                                                                                    <Row><Col style={{whiteSpace: "break-spaces"}}><CLabel labelText={t('data-lang-lbl-name')} labelValue={item.messageTitle} /> </Col></Row>
                                                                                    </div>
                                                                                </div>         
                                                                            </div>
                                                                        </div>
                                                                </div>   
                                                    }
                                                },
                                                {
                                                    key: 'status',
                                                    name: t('data-lang-lbl-status'),
                                                    fieldName: 'status',
                                                    minWidth: 80,
                                                    maxWidth: 80,
                                                    onRender:(item) => {
                                                        const [key, count] = (item.status ?? '').split(' ');
                                                        return <div className={`h-100 w-100 ${ item.id === inputParam_SelectedMessageId ? "selected-card" : "" }`} onClick={() => onCardTreeSelected(item)}>{`${t(key)}${count ? ` ${count}` : ''}`} </div>
                                                    }
                                                },
                                                {
                                                    key: 'messageSendDate',
                                                    name: t('data-lang-lbl-date'),
                                                    fieldName: 'messageSendDate',
                                                    minWidth: 230,
                                                    maxWidth: 230,
                                                    onRender:(item) => {
                                                        return <div className={`h-100 w-100 ${ item.id === inputParam_SelectedMessageId ? "selected-card" : "" }`} onClick={() => onCardTreeSelected(item)}>
                                                            <Row><Col style={{whiteSpace: "break-spaces"}}><CLabel labelText={t('data-lang-lbl-senddate')} labelValue={ moment(item.messageSendDate).format("DD/MM/YYYY") } /> </Col></Row>
                                                            {
                                                                item.answerNeeded &&
                                                                <Row><Col style={{whiteSpace: "break-spaces"}}><CLabel labelText={t('data-lang-lbl-answerdeadlinedate')} labelValue={ moment(item.deadlineDate).format("DD/MM/YYYY") } /> </Col></Row>
                                                            }
                                                        </div>;
                                                    }
                                                },
                                                {  
                                                    key: 'senderParty',
                                                    name: t('data-lang-lbl-sender'),
                                                    fieldName: 'senderParty',
                                                    minWidth: 100,
                                                    maxWidth: 100,
                                                    onRender:(item) => {
                                                        return <div className={`h-100 w-100 ${ item.id === inputParam_SelectedMessageId ? "selected-card" : "" }`} onClick={() => onCardTreeSelected(item)}>{ item.senderParty }</div>;
                                                    }
                                                },
                                                {  
                                                    key: 'receiversParty',
                                                    name: t('data-lang-lbl-sendedtopartys'),
                                                    fieldName: 'receiversParty',
                                                    minWidth: 150,
                                                    maxWidth: 150,
                                                    onRender:(item) => {
                                                        return <div className={`h-100 w-100 ${ item.id === inputParam_SelectedMessageId ? "selected-card" : "" }`} onClick={() => onCardTreeSelected(item)}>{ item.receiversParty }</div>;
                                                    }
                                                },
                                                {  
                                                    key: 'id',
                                                    name: t('data-lang-lbl-actions'),
                                                    fieldName: 'id',
                                                    minWidth: 20,
                                                    maxWidth: 20,
                                                    onRender:(item) => {
                                                        return "";
                                                    }
                                                }
                                            ] : [] }
                                            enableExport={ true }
                                            handleExport={ handleExport }
                                            exportFileName={"Listado de comunicaciones.xlsx"}
                                        />
                                    }
                                    { !tglCompactView &&
                                        <>
                                            <Row style={{fontWeight: "600", fontSize: "14px", paddingBottom: "10px", borderBottom: "2px solid #0078d4"}}>
                                                <Col className='col' style={{paddingTop : "11px"}} xxl={4}>
                                                    { t('data-lang-lbl-answerfrom') }
                                                </Col>
                                                <Col className='col' style={{paddingTop : "11px"}} xxl={4}>
                                                    { t('data-lang-lbl-message') }
                                                </Col>
                                                <Col className='col' style={{paddingTop : "11px"}} xxl={4}>
                                                    { t('data-lang-lbl-answeredby') }
                                                    <div className='float-end' style={{position: "relative", right: "10px", top: "2px"}}>
                                                        <ActionButton iconProps={{ iconName: lasSectionCollapsedExpanded === null ? 'CollapseContentSingle' : lasSectionCollapsedExpanded === false ? 'ExploreContentSingle' : 'CollapseContentSingle' }} styles={{root: {height: "20px"}}} onClick={() => onHideShowSectionTreeAll()} allowDisabledFocus >
                                                            { lasSectionCollapsedExpanded === null ? t('data-lang-lbl-collapseall') : lasSectionCollapsedExpanded === false ? t('data-lang-lbl-expandall') : t('data-lang-lbl-collapseall')  }
                                                        </ActionButton>
                                                    </div>
                                                </Col>                                
                                            </Row>
                                            <Row style={{ minHeight: "90%", maxHeight: "95%", height: "auto" }}>
                                                <ScrollablePane
                                                    style={{minHeight: "975px", maxHeight: "100%", height: "90%"}}
                                                    styles={{
                                                        root: { position: "relative" },
                                                        contentContainer:{overflowX: "hidden"}
                                                    }}
                                                    scrollbarVisibility={ScrollbarVisibility.auto}
                                                    scrollContainerFocus={true}
                                                >
                                                    {
                                                        inputParam_ObjMessageList && inputParam_ObjMessageList.data.data.map((section, indexSection) => 
                                                            section.seccionId === selectedFilterSectionId || selectedFilterSectionId === -1 ?
                                                            <Row style={{padding: "2px"}} key={indexSection}>
                                                                <Col xxl={12}>
                                                                    <Row onClick={() => onHideShowSectionTree(section.seccionId, section.show)} className='timeline-card-section-header'>
                                                                        {
                                                                            <Col>
                                                                                <b>{t('data-lang-lbl-section')}: </b> {section.seccionName}
                                                                                <div className='float-end' style={{position: "relative", right: "10px", top: "2px"}}>
                                                                                    <ActionButton iconProps={{ iconName: section.show ? 'CollapseContentSingle' : 'ExploreContentSingle' }} styles={{root: {height: "20px"}}} allowDisabledFocus >
                                                                                    </ActionButton>
                                                                                </div>
                                                                            </Col>
                                                                        }
                                                                    </Row>
                                                                    {
                                                                        section.l_items && section.l_items.map((message, index) => 
                                                                            checkIfSelectedSectionStadisticTypeCanBeDisplay(message) === true && section.show === true &&
                                                                            <Row xxl={12} className="timeline-card-row" key={ index }>
                                                                                <Col className='pe-3' xxl={4}>
                                                                                    {
                                                                                        message.item_message_in_answer_from &&
                                                                                        <Card
                                                                                            className={`timeline-card-right-arrow timeline-card 
                                                                                                ${ message.item_message_in_answer_from.id === inputParam_SelectedMessageId ? "selected-card" : "" }    
                                                                                            `}
                                                                                            onClick={ () => onCardTreeLateralSelected(message.item_message_in_answer_from, message.item_message) }>
                                                                                            <Card.Header>
                                                                                                <p>{ message.item_message_in_answer_from.messageCode }</p>
                                                                                            </Card.Header>
                                                                                            <Card.Body>
                                                                                                <h6>{ message.item_message_in_answer_from.messageTitle }</h6>
                                                                                                <h6>&nbsp;</h6>
                                                                                            </Card.Body>
                                                                                        </Card>
                                                                                    }
                                                                                </Col>
                                                                                <Col xxl={4}>
                                                                                    <div className={
                                                                                        `timeline-card 
                                                                                            ${ message.item_message.isUnread ? "status-card-yellow " : " "}
                                                                                            ${ !message.item_message.isUnread &&
                                                                                                !message.item_message.isPending &&
                                                                                                !message.item_message.isExpired? " status-card-green" : " "} `
                                                                                    }>
                                                                                        <div
                                                                                            
                                                                                            className={
                                                                                                `timeline-card-nested timeline-card 
                                                                                                ${ message.item_message.id === inputParam_SelectedMessageId ? "selected-card" : "" }
                                                                                                ${ message.item_message.isPending ? " status-card-orange" : " "}
                                                                                                `
                                                                                            }
                                                                                            onClick={ () => onCardTreeSelected(message.item_message) }
                                                                                        >
                                                                                            {
                                                                                                //[##CODELCO-CARD-##] Borradores Book
                                                                                                //Resaltar mensaje en borrador
                                                                                            }
                                                                                            <Card
                                                                                                style={{border: message.item_message.statusId === 1 ? '2px solid #ca4242' : 'unset'}}
                                                                                                className={
                                                                                                    `timeline-card-nested timeline-card 
                                                                                                    ${ message.item_message.id === inputParam_SelectedMessageId ? "selected-card" : "" }
                                                                                                    ${ message.item_message.isExpired ? " status-card-red" : " "}
                                                                                                    `
                                                                                                }
                                                                                                onClick={ () => onCardTreeSelected(message.item_message) }
                                                                                            >
                                                                                                <Card.Header>
                                                                                                    <div className='d-flex'>
                                                                                                    {
                                                                                                        inputParam_SelectedSectionStatusItem &&
                                                                                                        (inputParam_SelectedSectionStatusItem.type === "isUnread" ?
                                                                                                            message.item_message[inputParam_SelectedSectionStatusItem.type] === true :
                                                                                                            (inputParam_SelectedSectionStatusItem.type === "isTotalMessage" ? true : message.item_message[inputParam_SelectedSectionStatusItem.type] === true )) &&
                                                                                                        <Icon className='status-card-stadistic-section-selected' iconName="Glimmer" />
                                                                                                    }
                                                                                                    <p>{ message.item_message.messageCode }</p>
                                                                                                    </div>
                                                                                                    {
                                                                                                        message.item_message.isPending &&
                                                                                                        <Icon className='status-card-require-reply' iconName="StatusCircleExclamation" />
                                                                                                    }
                                                                                                </Card.Header>
                                                                                                <Card.Body>
                                                                                                    <h6><TooltipHost content={ message.item_message.messageTitle } >{ message.item_message.messageTitle }</TooltipHost></h6>
                                                                                                    <h6><TooltipHost content={ moment(message.item_message.messageSendDate).format("DD/MM/YYYY") } >{ moment(message.item_message.messageSendDate).format("DD/MM/YYYY") }</TooltipHost></h6>
                                                                                                    <MessageIconStatus acceptSendedStatus={false} statusId={ message.item_message.statusId } visa={message.item_message.visa} />
                                                                                                </Card.Body>
                                                                                            </Card>         
                                                                                        </div>
                                                                                    </div>
                                                                                </Col>
                                                                                <Col xxl={4}>        
                                                                                    {
                                                                                        message.item_message_l_is_answered_by && message.item_message_l_is_answered_by.map((subMessage, subIndex) => 
                                                                                            <Row key={subIndex} className={ subIndex === 0 ? "timeline-card-left-arrow" : "timeline-card-left-arrow pt-2"}>
                                                                                                <Col className='ps-3'>
                                                                                                    <Card
                                                                                                        className={`timeline-card 
                                                                                                            ${ message.item_message_l_is_answered_by.id === inputParam_SelectedMessageId ? "selected-card" : "" }    
                                                                                                        `}
                                                                                                        onClick={ () => onCardTreeLateralSelected(subMessage, message.item_message) }>
                                                                                                        <Card.Header className="d-flex">
                                                                                                            <p>{ subMessage.messageCode }</p>
                                                                                                        </Card.Header>
                                                                                                        <Card.Body>
                                                                                                            <h6>{ subMessage.messageTitle }</h6>
                                                                                                            <h6>&nbsp;</h6>
                                                                                                        </Card.Body>
                                                                                                    </Card>
                                                                                                </Col>
                                                                                            </Row>
                                                                                        )                                        
                                                                                    }
                                                                                </Col>
                                                                            </Row>
                                                                        )
                                                                    }
                                                                </Col>
                                                            </Row>
                                                            :
                                                            <></>
                                                        )
                                                    }
                                                </ScrollablePane>
                                            </Row>
                                        </>
                                    }
                                    <a className='d-none' id="exportTree"></a>
                                </Card.Body>
                                <Card.Footer>
                                    { tglCompactView && inputParam_ObjMessageListGridType && inputParam_ObjMessageListGridType.data &&
                                        <ListPagination
                                            listLocalStoragePageSizeVariableName="messageTree" 
                                            data={ (inputParam_ObjMessageListGridType !== null ? inputParam_ObjMessageListGridType : []) }
                                            setData={ inputParam_SetterObjMessageListGridType } />
                                    }
                                </Card.Footer>
                            </>
                        }
                    </>
                }
                {
                (isPanelOpen && inputParam_UserProps.username !== null) &&
                <SidePanelCreate
                    bookObject={inputParam_BookObject}
                    isPanelOpen={ isPanelOpen }
                    setterIsPanelOpen={ setIsPanelOpen } 
                    userProps={ inputParam_UserProps } 
                    currentUserName={ inputParam_UserName } 
                    setterObjMessageList={ inputParam_SetterObjMessageList }
                    setterMessageObject={ inputParam_SetterMessageObject }
                    setFireGetMessage={inputParam_SetFireGetMessage}
                />
            }
        </Card>
    );
}

export default MessageTree;